import { patientNamespace } from "@/store/modules/patient";
import { ViewConfig } from "@/store/modules/patient/config";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class SelectView extends Vue {
  @Getter("selectedView", patientNamespace)
  selectedView!: string;

  @Getter("views", patientNamespace)
  views!: ViewConfig[];

  updateView(view: string) {
    const newRoute: any = { params: { view } };
    const selectedViewConfig = this.views.filter(v => {
      return v.routerString === view;
    });
    if (
      selectedViewConfig.length === 1 &&
      selectedViewConfig[0].defaultSortRoute
    ) {
      newRoute.params.sort = selectedViewConfig[0].defaultSortRoute;
    }
    this.$router.replace(newRoute);
  }
}
